<ng-template #loadingOrError>
	<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>
</ng-template>
<div class="container-block">
	<ng-container *ngIf="!isLoading && !isError else loadingOrError">
		<div class="container-inner-block">
			<div class="copo-container header-block">
				<div class="copo-section-body copo-grid">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>offers.create.details.customer.offer-name</div>
								<div class="card-content-value width-content "
									[matTooltip]="rfqRef ? rfqRef : UNDERSCORE">
									{{ rfqRef ? rfqRef : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer.customer</div>
								<div class="card-content-value width-content" [matTooltip]="soldTo ? soldTo : UNDERSCORE">
									{{ soldTo ? soldTo : UNDERSCORE }} </div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer.wizard.delivery.address</div>
								<div class="card-content-value width-content" [matTooltip]="shipTo ? shipTo : UNDERSCORE">
									{{ shipTo ? shipTo : UNDERSCORE }} </div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer.create.enduser</div>
								<div class="card-content-value width-content" [matTooltip]="endUser ? endUser : UNDERSCORE">
									{{ endUser ? endUser : UNDERSCORE }} </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!isLoading && !isError else loadingOrError">
		<div class="product-family-block">
			<div class="card-infos">
				<div *ngIf="selectedPeriodDateDisplay" class="card-info commitment-period">
					<div class="card-info-bold" translate>eoffer.header.commitment.period&nbsp;</div>
					<div *ngIf="selectedPeriodDisplay">
						<span [matTooltip]="selectedPeriodDateDisplay">{{selectedPeriodDateDisplay}} </span>
						<span> [ </span>
						<span class="card-info-bold"> {{ selectedPeriodDisplay }} </span>
						<span> ] </span>
					</div>
					<div *ngIf="selectedPeriodDisplay === ''">
						<span [matTooltip]="selectedPeriodDateDisplay">{{selectedPeriodDateDisplay}}</span>
					</div>
				</div>
			</div>
			<div *ngIf="getProductFamiliesHavingItemInCart.length > 0" class="card-infos">
				<ng-container *ngFor="let productsFamily of getProductFamiliesHavingItemInCart; let i=index">
					<div class="card-info-2"
						(click)="scrollToGivenFamily(i)"
						(keydown.enter)="scrollToGivenFamily(i)" 
						(keydown.space)="scrollToGivenFamily(i)" 
						tabindex="0">
						<span class="copo-offer-product-family-details">{{productsFamily.subCategoryDescription}} ({{productsFamily.formDescription}})</span>
						<span class="copo-offer-total-quantity">{{ getQuantityByFamilyCode(productsFamily.code) }}&nbsp;t</span>
						<span class="copo-offer-total-label" translate>eoffer.header.total</span>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!isLoading && !isError && isMerged else loadingOrError" class="warning">
		<div class="copo-notification-block">
			<mat-icon class="matclass" svgIcon="alert" [attr.title]="'offline.alert' | translate"></mat-icon>
			<div class="copo-offer-flex-container-col">
				<div translate>global.warning</div>
				<div class="card-header-label" translate>eoffer.merge.warning</div>
			</div>
		</div>
	</ng-container>
</div>
<ng-container *ngIf="form.getFormProducts().length > 0; else noProducts;">
	<ng-container *ngFor="let productFamily of getProductFamiliesHavingItemInCart; let isFirst = first">
		<div class="product-list-group" #rows>
			<div class="copo-container cart-title">
				<div class="cart-title-heading"> <span *ngIf="isFirst" translate>eorder.wizard.product.modification.title.cart</span> </div>
				<div class="cart-title-content"> {{getProductsCountByCode(productFamily.code)}} <span translate>eorder.wizard.product.modification.title.items</span> </div>
				<div class="cart-product-family">
					<span class="pf-sub-category">{{productFamily?.subCategoryDescription}}</span>
					<span class="pf-form">&nbsp;({{productFamily?.formDescription  | titlecase}})</span>
				</div>
			</div>
			<div class="family-by-volum-block" *ngIf="offerType !== 'spot'">
				<copo-offer-pcp-split
					[formFromDate]="getFromDate()" [formToDate]="getToDate()"
					[formFamilyByVolumes]="getFormFamilyByVolumes(productFamily.code)"
					[code]="productFamily.code" [isReadOnly]="true" #offerPcpSplit>
				</copo-offer-pcp-split>
			</div>
			<div class="product-list-view">
				<copo-offer-product-list-quantity
					#table
					[uniqueRefList]="getUniqueRefListByCode(productFamily.code)"
					[formProducts]="getformProductsByCode(productFamily.code)"
					[code]="productFamily.code"
					[category]="productFamily.category"
					[subCategory]="productFamily.subCategory"
					[form]="productFamily.form"
					[isReadOnly]="true">
				</copo-offer-product-list-quantity>
			</div>
		</div>
	</ng-container>
</ng-container>
<ng-template #noProducts>
	<div class="copo-container cart-title">
		<div class="cart-title-heading"> <span translate>eorder.wizard.product.modification.title.cart</span> </div>
		<div class="cart-title-content"><span translate>woe.noitems</span></div>
		<div class="cart-product-family">
			<span class="pf-sub-category">{{UNDERSCORE}}</span>
			<span class="pf-form">&nbsp;({{UNDERSCORE}})</span>
		</div>
	</div>
	<div class="copo-error-label">
		<span translate>eorder.wizard.product.modification.no.products</span>
	</div>
</ng-template>